import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import { configureBackend } from './helpers/auth-backend';

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  configureBackend();
} else {
  configureBackend();
}

var today = new Date();
var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

let user = localStorage.getItem('user');
let last = localStorage.getItem('time');

if(user){
  console.log('last', last);
  console.log('now', time);
  // localStorage.setItem('time', time);
}

const theme = localStorage.getItem('theme');

// import("./design/index-dark.scss");
if (theme === 'light') {
  import("./design/index.scss");
} else {
  import("./design/index-dark.scss");
}

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC3g_el7M_Y0VrehuqjpLfUV9O7mKWBKeQ',
    libraries: ['places', 'geometry'],
  },
  installComponents: true
})

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
